import { useState, useEffect } from 'react';
import Timer from '../components/Timer';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';

const mission = {
    time: 40 // 40 minutes
}
export default function Mission4(props) {
    const isMobile = window.innerWidth <= 1024
    const [remainingTime, setremainingTime] = useState(40 * 60); //40 mins
    const [startTime, setStartTime] = useState(new Date());
    const getRemainingTimeString = () => {
        if ((!remainingTime) || remainingTime <= 0) return '00:00'
        let time = remainingTime
        let hours = Math.floor(time / 3600);
        let minutes = Math.floor((time - (hours * 3600)) / 60);
        let seconds = Math.floor(time - (hours * 3600) - (minutes * 60));
        //return `${hours < 10 ? `0` : ''}${hours}:${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
        return `${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
    }
    useEffect(() => {
        let timeInterval = null
        timeInterval = setInterval(() => {
            let second = (startTime.getTime() + mission.time * 60 * 1000 - Date.now()) / 1000
            setremainingTime(second <= 0 ? 0 : second)
        }
            , 1000)
        return () => { clearInterval(timeInterval) }
    }, [startTime])


    const [question1TabIndex, setQuestion1TabIndex] = useState(0);
    const [question1SelectedAnswers, setQuestion1SelectedAnswers] = useState([]);
    const [question1PopupVisible, setQuestion1PopupVisible] = useState(false);

    const [question2TabIndex, setQuestion2TabIndex] = useState(0);
    const [question2SelectedAnswers, setQuestion2SelectedAnswers] = useState([]);
    const [question2PopupVisible, setQuestion2PopupVisible] = useState(false);

    const [showWrongAnswerPopup, setShowWrongAnswerPopup] = useState(false);

    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[black]' style={{ overflowY: "auto", fontSize: isMobile ? 12 : '1.5rem' }}>
            {/*header*/}
            <div className='w-full flex flex-row justify-between items-center bg-[black]' style={{ gap: isMobile ? '4px' : '16px', overflow: 'auto', paddingLeft: isMobile ? 8 : 24, paddingRight: isMobile ? 8 : 24, height: isMobile ? 50 : 65 }}>
                <Timer text={getRemainingTimeString()} percentage={(1 - ((remainingTime || 0) / ((mission.time * 60) || 1))) * 100} />
            </div>
            {/*end of header*/}

            {/*content*/}
            <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]' style={{ overflow: 'hidden' }}>
                {/*webpages*/}
                <div className='flex flex-col w-full bg-[white]' style={{ border: isMobile ? '2px solid black' : '2px solid black', padding: isMobile ? 4 : 10 }}>

                    <div className='w-full flex flex-row bg-[white] items-center' style={{ border: isMobile ? '2px solid black' : '2px solid black', marginTop: 4, marginBottom: 4, gap: isMobile ? 2 : 6, padding: isMobile ? 2 : 6 }}>
                        <div className='cursor-pointer'>
                            <PreviousSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <NextSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <ReloadSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='flex-1'>
                            <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={'https://reading-practice.com'} style={{ fontSize: isMobile ? 10 : 16, height: isMobile ? 26 : 40, paddingLeft: isMobile ? 12 : 24, paddingRight: isMobile ? 12 : 24 }} />
                        </div>
                    </div>
                    {/*end tabs*/}

                    {/*web content*/}
                    <div className='flex w-full flex-1 bg-[white] flex-col justify-start' style={{ overflowY: 'auto', border: '2px solid black' }}>
                        <img src='/閱讀策略/1-01.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />

                        <div className='w-full bg-[#DDF6F2] flex flex-col justify-start p-[32px] items-center'>
                            <div className='w-full max-w-[1200px]' style={{ textAlign: 'justify' }}>
                                假設有人問你：動物是怎麼散熱的？如果你不知道答案，是不是會上網查找呢？在網上查找，會有一些「顯性信息」。所謂的「顯性信息」，就是答案「清清楚楚」出現在畫面上。有時候，這些訊息是在圖片、圖表或影片裏。
                                <br /><br />
                                怎麼找呢？兩步教你輕鬆達標：<br /><br />
                            </div>

                        </div>
                        <img src='/閱讀策略/1-02.jpg' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <img src='/閱讀策略/b1.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <div className='w-full bg-[#E3F2FE] flex flex-col items-center justify-start p-[16px] items-center'>
                            <div className='w-full bg-[#E3F2FE] flex flex-row justify-start p-[16px] items-center max-w-[1200px]'>
                                <div className='p-[16px] flex-1' style={{ textAlign: 'justify' }}>
                                    <mark>貓</mark>的汗腺主要在腳掌，用來<mark>散熱</mark>。因此，在夏天來臨時，建議剪掉貓的腳掌上較長的毛髮，但不能剪光全部的毛髮，因為這會使牠們受到病菌的傷害。
                                </div>
                                <div className='flex flex-col items-center' style={{ textAlign: 'center' }}>
                                    <img src='/閱讀策略/1-03.png' style={{ maxWidth: '200px', objectFit: 'contain' }} alt='閱讀策略' />
                                    <div>圖1 <mark>修剪貓的毛髮</mark></div>
                                </div>

                            </div>
                            <div className='w-full bg-[#E3F2FE] flex flex-col justify-start p-[32px] items-center max-w-[1200px]'>
                                黃色標示的文字和圖片，就是跟主題詞「小貓」和「散熱」有關了，找到後仔細閱讀，理解圖意，把兩者結合起來，就能找到答案。
                                <br /><br />
                                <div className='w-[80%] flex flex-col rounded-[24px] p-[16px] text-center' style={{border:'1px solid black'}}>
                                    <b>答案</b>
                                    <br/>
                                    原來，小貓散熱是靠它的腳掌上的汗腺。剪掉腳掌上較長的毛髮，就可以幫助小貓散熱了！
                                </div>
                                <br /><br />
                                <div className='w-full h-[1px] bg-black'/>
                                <br />
                                有時候，上網找資料時，答案不只寫在文字裏，還會藏在圖片或圖表中。小朋友都愛吃零食，特別是巧克力。可是，每日吃多少才合適呢？想知答案，就上網找出營養師建議每日吃黑巧克力的份量吧！

                            </div>
                        </div>
                        <div className='w-full bg-[#FBF6BC] flex flex-col items-center justify-start p-[16px] items-center'>
                            <img src='/閱讀策略/1-04.png' style={{ maxWidth: 'min(100%, 600px)', objectFit: 'contain' }} alt='閱讀策略' />
                            <div className='w-full flex flex-col justify-start p-[32px] items-center max-w-[1200px]'>
                                找出「黑巧克力」和「每日份量」這兩個關鍵字，再細看圖表裏的數字和說明，就能找到答案。
                                <br /><br />
                                {/* 答案<br/><br/>營養師建議每日約吃3-5小片黑巧克力。你做對了嗎？ <br /> */}
                                <div className='w-[80%] flex flex-col rounded-[24px] p-[16px] text-center' style={{border:'1px solid black'}}>
                                    <b>答案</b>
                                    <br/>營養師建議每日約吃3-5小片黑巧克力。
                                </div>
                                <br/>
                                你做對了嗎？

                            </div>
                        </div>




                        <img src='/閱讀策略/b2.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <div className='w-full bg-[#DDFBF6] flex flex-col justify-start p-[32px] items-center'>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>

                                同學們，學會了「找有關的顯性訊息」策略後，現在輪到你們試一試啦！
                                <br />       <br />

                                大象的祖先猛瑪象生活在寒冷的環境中，身上長滿毛髮來讓自己暖和。現在大象身體的毛髮數量減少，能防止身體温度過高。大象的血液流過牠的耳朵時會散熱，再加上搖擺耳朵的動作，血液的温度就會降低。通常大象耳朵越大，散熱效果越好。

                                <br />

                            </div>
                            <br />
                            <img src='/閱讀策略/task1-03.png' style={{ maxWidth: '500px', objectFit: 'contain' }} alt='閱讀策略' />
                            <div>圖1 大象的祖先猛瑪象</div>
                            <br />
                            <br />





                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[700px] bg-[#E3F2FE] p-[16px]'>
                                <div className='w-full'>
                                    1. 猛瑪象身體的毛髮有甚麼作用？
                                </div>
                                {[
                                    { text: "A. 走路加快 ", id: 'A' },
                                    { text: "B. 保持暖和 ", id: 'B' },
                                    { text: "C. 減少吃飯 ", id: 'C' },
                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = [...question1SelectedAnswers]
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion1SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question1SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
                                        //if only select B show correct popup
                                        if (question1SelectedAnswers.length === 1 && question1SelectedAnswers.includes('B')) {
                                            setQuestion1PopupVisible(true)
                                        } else {
                                            setShowWrongAnswerPopup(true)
                                        }
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>


                        {/*question2*/}
                        <div className='w-full bg-[#DDFBF6] flex flex-col justify-start p-[32px] items-center'>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                <table border="1" className='w-full' style={{ border: '1px solid black' }}>
                                    <tr style={{ borderBottom: '1px solid black',backgroundColor: '#008EBA', color: 'white' }}>
                                        <th>角色</th>
                                        <th>圖例</th>
                                        <th>説明</th>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid black' }}>
                                        <td>黑色</td>
                                        <td>
                                            <img src='/閱讀策略/task1-04.png' alt='法海' className='max-w-[100px] w-full' style={{ objectFit: 'contain' }} />
                                            法海
                                        </td>
                                        <td>普遍表現人物鐵面無私與剛直的形象</td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid black' }}>
                                        <td>金、銀</td>
                                        <td>
                                            <img src='/閱讀策略/task1-05.png' alt='黑虎趙靈官' className='max-w-[100px] w-full' style={{ objectFit: 'contain' }} />
                                            黑虎趙靈官
                                        </td>
                                        <td>普遍為神佛，象徵其金身不滅</td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid black' }}>
                                        <td>紅色</td>
                                        <td>
                                            <img src='/閱讀策略/task1-06.png' alt='二郎神' className='max-w-[100px] w-full' style={{ objectFit: 'contain' }} />
                                            二郎神
                                        </td>
                                        <td>普遍表現人物忠烈的形象</td>
                                    </tr>
                                </table>
                            </div>
                            <br /><br />
                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[600px] bg-[#D0E9FF] p-[16px]'>
                                <div className='w-full'>
                                    2.	京劇臉譜中的「金、銀」色通常用來表現哪一類角色的形象？
                                </div>


                                {[
                                    { text: "A.	鐵面無私 ", id: 'A' },
                                    { text: "B. 神佛", id: 'B' },
                                    { text: "C. 忠烈", id: 'C' },
                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = [...question2SelectedAnswers]
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion2SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question2SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
                                        if (question2SelectedAnswers.length === 1 && question2SelectedAnswers.includes('B')) {
                                            setQuestion2PopupVisible(true)
                                        } else {
                                            setShowWrongAnswerPopup(true)
                                        }
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>
                        <br />




                        {/*return button*/}
                        <button onClick={props.onClose} className='mt-4 px-4 py-2 bg-blue-500 text-white rounded m-[32px]'>返回</button>


                    </div>
                    {/*end of web content*/}




                </div>
                {/*end of webpages*/}






            </div>

            {question1PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答案：保持暖和</div>
                        <div className='w-full max-w-[700px]'>
                            解析： 根據題目關鍵字「猛瑪象的毛髮」、「作用」，定位文章第一句「身上長滿毛髮來讓自己暖和」，即可選出答案 B。
                        </div>
                        <button onClick={() => setQuestion1PopupVisible(false)} className='mt-4 px-[24px] py-2 text-white rounded-full bg-[#0000FF]' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}
            {question2PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答案：B</div>
                        <div className='w-full max-w-[700px]'>
                            解析：根據題目關鍵字「金、銀」，定位表格第二行，說明欄明確寫著「普遍為神佛」，所以答案是 B。
                        </div>
                        <button onClick={() => setQuestion2PopupVisible(false)} className='mt-4 px-[24px] py-2 text-white rounded-full bg-[#0000FF]' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}

            {showWrongAnswerPopup && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答錯了，請再嘗試！</div>
                        <button onClick={() => setShowWrongAnswerPopup(false)} className='mt-4 px-[24px] py-2 text-white rounded-full bg-[#0000FF]' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}




        </div>
    )
}